<template>
  <div
    :id="data.lineTxt.toLowerCase()"
    :class="['box', getStylingClass || 'status-wip']"
  >
    <header :class="`bg-${data.lineTxt.toLowerCase()}`">
      <img
        v-if="
          getStylingClass == 'status-nan' ||
          getStylingClass == 'status-out-of-service' ||
          getStylingClass == 'status-wip'
        "
        :alt="data.lineTxt"
        :src="`https://bvg-cdn.de/signets/${data.lineTxt.toLowerCase()}_grau.svg`"
      />
      <img
        v-else
        :alt="data.lineTxt"
        :src="`https://bvg-cdn.de/signets/${data.lineTxt.toLowerCase()}.svg`"
      />
    </header>

    <div>
      <WipFlatterband v-if="data.hasDisruption" />
    </div>

    <main>
      <TabStufeNaN v-if="!getStylingClass || getStylingClass == 'status-nan'" />
      <TabStufe0 v-if="getStylingClass == 'status-wip'" />
      <TabStufe1 v-if="getStylingClass == 'status-okay'" />
      <TabStufe2 v-if="getStylingClass == 'status-notice'" />
      <TabStufe3 v-if="getStylingClass == 'status-warning'" />
      <TabStufe4 v-if="getStylingClass == 'status-out-of-service'" />
    </main>
  </div>
</template>

<script>
import WipFlatterband from './WipFlatterband.vue';
import TabStufeNaN from './TabStufeNaN.vue';
import TabStufe0 from './TabStufe0.vue';
import TabStufe1 from './TabStufe1.vue';
import TabStufe2 from './TabStufe2.vue';
import TabStufe3 from './TabStufe3.vue';
import TabStufe4 from './TabStufe4.vue';

export default {
  components: {
    WipFlatterband,
    TabStufeNaN,
    TabStufe0,
    TabStufe1,
    TabStufe2,
    TabStufe3,
    TabStufe4,
  },
  props: { data: { type: Object, required: true } },
  computed: {
    getStylingClass() {
      return this.data.manuallyClass || this.data.statusClass || null;
    },
  },
};
</script>

<style scoped>
.box {
  display: grid;
  grid-template-rows: var(--box-line) var(--flatterband) calc(
      var(--box-height) - var(--box-line) - var(--flatterband)
    );
  overflow: hidden;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
  background: #fff;
  z-index: 1;

  height: var(--box-height);
  width: var(--box-width);
}

.status-out-of-service {
  box-shadow: none;
  background: var(--step-oos-bg);
}

.status-nan,
.status-wip {
  background: var(--step-wip-bg);
}

.status-okay {
  background: var(--step-1-bg);
}

.status-notice {
  background: var(--step-2-bg);
}

.status-warning {
  background: var(--step-3-bg);
}

header {
  display: flex;
  justify-content: center;
  text-align: center;
}

main {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
